<template>
  <div class="impressao-dados-cenario-modulo">
    <div class="impressao-dados-coluna impressao-dados-divide-pagina-a">
      <h2>Dados do Cenário</h2>
      <div class="impressao-dados-linha">
        <ImpressaoBloco :nome="'Tipo de Operação:'" :dado="dadosCenario.tipoDeOperacao" />
        <ImpressaoBloco
          v-if="dadosCenario.mostraUfOrigem"
          :nome="'UF Origem:'"
          :dado="dadosCenario.ufOrigem"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraPaisOrigem"
          :nome="'País Origem:'"
          :dado="dadosCenario.paisOrigem"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraUfDestino"
          :nome="'UF Destino:'"
          :dado="dadosCenario.ufDestino"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraPaisDestino"
          :nome="'País Destino:'"
          :dado="dadosCenario.paisDestino"
        />
      </div>
      <div v-if="dadosCenario.zfm == 1" class="impressao-zfm">
        <p>
          Com tratamento tributário diferenciado para operações com a Zona Franca de Manaus, Área de
          Livre Comércio e Amazônia Ocidental.
        </p>
      </div>
    </div>

    <div
      v-show="impressaoMostraMerc"
      class="impressao-dados-coluna impressao-dados-divide-pagina-b"
    >
      <h2>Mercadoria</h2>
      <div class="impressao-dados-linha">
        <ImpressaoBloco
          v-if="dadosCenario.mostraOrigem"
          meio
          :nome="'Origem:'"
          :dado="dadosCenario.origem"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraDestinacao"
          meio
          :nome="'Destinação:'"
          :dado="dadosCenario.destinacao"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImpressaoBloco from "./ImpressaoBloco.vue";

export default {
  name: "ImpressaoOperacao",
  components: { ImpressaoBloco },
  props: {
    dadosCenario: Array | Object
  },
  computed: {
    impressaoMostraMerc() {
      if (this.dadosCenario.mostraOrigem || this.dadosCenario.mostraDestinacao) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.impressao-dados-cenario-modulo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.impressao-dados-coluna {
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  h4 {
    font-size: 12px;
    font-weight: bold;
  }
}
.impressao-dados-linha {
  display: flex;
  flex-direction: row;
}
.impressao-dados-divide-pagina-a {
  width: 60%;
}
.impressao-dados-divide-pagina-b {
  width: 40%;
}
.impressao-zfm {
  margin-right: 20px;
}
</style>
